/**
 *
 * Audiences Routes
 *
 * Please note: routes need to be added in main routes file at src/modules/routes.js
 * or src/{mobileApp/webApp}/routes.js depending on current file location
 */

import { lazyLoad } from 'utils/loadable';

export const AudiencesPage = lazyLoad(
  () =>
    import(
      /*  webpackChunkName: 'AudiencesPage', webpackPrefetch: true */ './index'
    ),
  module => module.default,
);

// routes declaration
export const audiencesRoutes = [
  {
    component: AudiencesPage,
    path: '/audiences',
    title: 'Audiences',
    needsAuth: true,
    hidePublicNavbar: true,
    hideCustomFooter: true,
    allowedAfterLogin: true,
  },
];
